import React from 'react';
import { nanoid } from 'nanoid';
import { create } from 'zustand';
import { AlertTypes } from '@/components/shared';

export interface NotificationProps {
	children: React.ReactNode;
	type: AlertTypes;
	options?: {
		duration?: number;
		isClosable?: boolean;
	};
	id?: string;
}

interface NotificationStoreProps {
	notifications: NotificationProps[];
	addNotification: (notification: NotificationProps) => void;
	removeNotification: (id: string) => void;
	clearNotifications: () => void;
}

export const useNotificationStore = create<NotificationStoreProps>((set) => ({
	notifications: [],
	addNotification: (notification): void => {
		set((state) => ({
			notifications: [
				...state.notifications,
				{
					...notification,
					options: {
						duration: 3000,
						isClosable: true,
						...notification.options,
					},
					id: notification.id || nanoid(),
				},
			],
		}));
	},
	removeNotification: (id): void => {
		set((state) => ({
			notifications: state.notifications.filter((item) => item.id !== id),
		}));
	},
	clearNotifications: (): void => {
		set({ notifications: [] });
	},
}));
